import { logger } from '../../../../util/logger';
import { NumericFormat } from '../component/widget/widget.types';

export const getNumericFormatSuffix = (format: NumericFormat): string => {
  switch (format) {
    case NumericFormat.Percentage:
      return '%';
    case NumericFormat.Degree:
      return '°';
    default:
      logger.warn('Unsupported numeric format', { format });
      return '';
  }
};
